import "jquery";
import "document-outline";
import "smooth-scroll";
console.log("hello");
// Use it
$("[data-in-page-menu]").each(function() {

    var menu = $(this);
    var doc = $(menu.attr("data-in-page-menu"));

    doc.documentOutline(menu);
    menu.find("a").smoothScroll();
});